<template>
    <div>
        <h2 class="ix-page-title-secondary mt-4">Frais engagés</h2>
        <div class="row">
            <div class="col-sm-12">
                <div class="alert alert-info">Les justificatifs seront à transmettre sur la page suivante</div>

                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <thead>
                        <tr>
                            <th style="width: 30px;"></th>
                            <th style="width: 200px;">Date</th>
                            <th>Payé à</th>
                            <th style="width: 300px;">Nature</th>
                            <th style="width: 60px;" class="text-center">
                                <span data-toggle="tooltip" data-placement="top" title="CB société, carte d'affaires, ..">
                                    C. PRO <i class="fas fa-question-circle"></i>
                                </span>
                            </th>
                            <th class="text-right" style="width: 180px;">Montant réglé</th>
                            <th class="text-right" style="width: 180px;">Dont TVA</th>
                            <th style="width: 120px;"></th>
                        </tr>
                        </thead>
                        <draggable v-model="lines" tag="tbody" handle=".handle-line" v-if="!loading">
                            <tr v-for="(line, index) in lines" is="expense-report-line-form"
                                v-bind:key="line.uniq"
                                :line="line"
                                :index="index"
                                :companiesRoute="companiesRoute"
                                :dealsRoute="dealsRoute"
                                :line-error="lineError"
                                :types="JSON.parse(types)"
                                v-on:line-editing-started="checkIfNewRowNeeded($event)"
                                v-on:line-deleted="deleteRow($event)"
                                v-on:line-manage-users-started="openUsersModal($event)"
                            ></tr>
                        </draggable>
                        <tbody>
                        <tr v-if="!loading">
                            <td></td>
                            <td colspan="4">Total des frais dûs</td>
                            <td class="text-right ix-text-large ix-text-bold">{{ currency(total_ttc) }}</td>
                            <td colspan="2"></td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="8" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <button type="button" class="ix-btn link" @click="addRow(null)"><i class="far fa-plus"></i> Nouvelle ligne</button>
            </div>
        </div>

        <div class="modal fade" id="usersModal" tabindex="-1" aria-labelledby="usersModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-show="selectedIndexLine != null">
                    <div class="modal-header">
                        <h5 class="modal-title">Sélection des accompagnateurs</h5>
                    </div>
                    <div class="modal-body">
                        <div class="ix-table-box mb-3">
                            <table class="ix-table">
                                <tbody v-if="selectedIndexLine != null">
                                    <tr v-for="(user, index) in lines[selectedIndexLine].users" v-bind:key="index">
                                        <td>
                                            {{ user.fullname }}
                                        </td>
                                        <td class="text-right">
                                            <button type="button" class="btn btn-sm transparent" @click="deleteUser(index)">
                                                <i class="far fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="userSearchInput" type="text" v-model="searchUser">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-footer" v-if="selectedIndexLine != null">
                        <button type="button" class="ix-btn green" @click="validUsers()">Enregistrer</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ExpenseReportLineForm from "./ExpenseReportLineForm";
    import draggable from 'vuedraggable';

    export default {
        name: 'expense-report-line-table-form',
        props: ['oldLines', 'companiesRoute', 'usersRoute', 'dealsRoute', 'types', 'lineErrors'],
        components : {
            ExpenseReportLineForm,
            draggable
        },
        data() {
            return {
                loading: true,
                lines: [],
                selectedIndexLine: null,
                searchUser: null,
                lineError: null,
            };
        },
        computed: {
            total_ht: function() {
                var sum = 0;
                this.lines.forEach(line => {
                    if (!line.pro) {
                        sum += parseFloat(line.total_ht)
                    }
                });
                return sum;
            },
            total_vat: function() {
                var sum = 0;
                this.lines.forEach(line => {
                    if (!line.pro) {
                        sum += parseFloat(line.total_vat)
                    }
                });
                return sum;
            },
            total_ttc: function() {
                var sum = 0;
                this.lines.forEach(line => {
                    if (!line.pro) {
                        sum += parseFloat(line.total_ttc)
                    }
                });
                return sum;
            }
        },
        methods : {
            addRow: function (line) {
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    payed_at: '',
                    company_name: '',
                    company_id: null,
                    deal_designation: '',
                    deal_id: null,
                    type: null,
                    type_other: '',
                    pro: 0,
                    total_ht: 0,
                    total_vat: 0,
                    total_ttc: 0,
                    users: [],
                }

                if (line != null) {
                    data.id = line.id
                    data.payed_at = line.payed_at
                    data.company_name = line.company_name
                    data.deal_designation = line.deal_designation
                    data.description = line.description
                    data.company_id = line.company_id
                    data.deal_id = line.deal_id
                    data.type = line.type
                    data.type_other = line.type == 0 ? line.type_other : ''
                    data.pro = line.pro
                    data.total_ht = line.total_ht
                    data.total_vat = line.total_vat
                    data.total_ttc = line.total_ttc
                    data.users = line.users ? line.users : []
                }

                this.lines.push(data)
            },
            deleteRow: function (index) {
                this.lines.splice(index, 1)
                if (this.lines.length == 0) {
                    this.addRow()
                }
            },
            checkIfNewRowNeeded: function (index) {
                if (this.lines.length > 0) {
                    if (this.lines.length - 1 == index) {
                        this.addRow()
                    }
                }
            },
            getLines: async function (route) {
                this.loading = true;
                fetch(route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data.forEach(line => {
                        this.addRow(line)
                    })
                    this.addRow(null)
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
            openUsersModal(index) {
                this.selectedIndexLine = index
                $('#usersModal').modal()
            },
            validUsers() {
                this.selectedIndexLine = null
                $('#usersModal').modal('hide')
            },
            deleteUser(index) {
                this.lines[this.selectedIndexLine].users.splice(index, 1)
            },
            getCurrentSelectedUsersId() {
                var usersIds = []

                if (this.selectedIndexLine != null) {
                    usersIds = this.lines[this.selectedIndexLine].users.map(user => user.id);
                }

                return usersIds
            }
            
        },
        mounted(){
            this.lineError = JSON.parse(this.lineErrors)
            const jsonLineBackup = JSON.parse(this.oldLines)
            if (Array.isArray(jsonLineBackup)) {
                if (jsonLineBackup.length == 0) {
                    this.addRow(null)
                } else {
                    jsonLineBackup.forEach(line => {
                        this.addRow(line)
                    })
                }
                this.loading = false
            } else {
                this.getLines(jsonLineBackup)
            }

            $("#userSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.usersRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedUsersId().join(';') + (';' + $('#user_id').val()) },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.fullname,
                                    value: item.fullname
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.searchUser = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.lines[this.selectedIndexLine].users.push(item.item)
                        $(e.target).val("")
                        this.searchUser = null
                    }
                }
            }).focus(() => {
                $("#userSearchInput").autocomplete("search", '');
            });
        }
    }
</script>
